import type {
  BuyerSimProposalVersion,
  BuyerSimulationBidResponse,
  BuyerSimulationMinimalBidResponse,
} from '../../../entities/BuyerSimBidResponse';
import { magellanClient } from '../../../infra/axios';
import type { GetBuyerSimulationBidResponseListResponseDTO } from './dto';

export async function getBuyerSimulationBidResponseList(): Promise<
  BuyerSimulationMinimalBidResponse[]
> {
  const response =
    await magellanClient.get<GetBuyerSimulationBidResponseListResponseDTO>(
      `/buyerSimBidResponses`,
    );
  return response.data.results;
}

export async function getBuyerSimulationBidResponse(
  id: number,
): Promise<BuyerSimulationBidResponse> {
  const response = await magellanClient.get<BuyerSimulationBidResponse>(
    `/buyerSimBidResponses/${id}`,
  );
  return response.data;
}

export async function createBuyerSimulationBidResponse(
  formData: FormData,
): Promise<BuyerSimulationBidResponse> {
  {
    const response = await magellanClient.post<BuyerSimulationBidResponse>(
      `/buyerSimBidResponses`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data as BuyerSimulationBidResponse;
  }
}

export async function updateBuyerSimulationBidResponse(
  buyerSimBidResponseId: number,
  additionalContext?: string,
  workspaceRelationWithBuyer?: string,
  workspaceResponseStrategy?: string,
): Promise<BuyerSimulationBidResponse> {
  const response = await magellanClient.put(
    `/buyerSimBidResponses/${buyerSimBidResponseId}`,
    {
      additionalContext,
      workspaceRelationWithBuyer,
      workspaceResponseStrategy,
    },
  );
  return response.data;
}
export async function createBuyerSimProposalVersion(
  buyerSimBidResponseId: number,
  formData: FormData,
): Promise<BuyerSimProposalVersion> {
  const response = await magellanClient.post(
    `/buyerSimBidResponses/${buyerSimBidResponseId}/proposalVersions`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
}

export async function getBuyerSimProposalVersion(
  buyerSimBidResponseId: number,
  buyerSimProposalVersionId: number,
): Promise<BuyerSimProposalVersion> {
  const response = await magellanClient.get<BuyerSimProposalVersion>(
    `/buyerSimBidResponses/${buyerSimBidResponseId}/proposalVersions/${buyerSimProposalVersionId}`,
  );
  return response.data;
}

export async function deleteBuyerSimBidRequirement(
  buyerSimBidResponseId: number,
  buyerSimBidRequirementId: number,
  deletionReason?: string,
) {
  await magellanClient.post(
    `/buyerSimBidResponses/${buyerSimBidResponseId}/buyerSimBidRequirements/${buyerSimBidRequirementId}/delete`,
    {
      deletionReason,
    },
  );
}
